import React, { useEffect, useState } from 'react';
import { auth, db } from '../LoginComp/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import './earnpoint.css';

function EarnPoint() {
  const [points, setPoints] = useState(0);
  const maxPoints = 100;

  useEffect(() => {
    const fetchUserPoints = async () => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        try {
          const uploadRef = collection(db, "uploadresource");
          const q = query(uploadRef, where("contributorEmail", "==", currentUser.email));
          const querySnapshot = await getDocs(q);

          const totalPoints = Math.min(querySnapshot.size, maxPoints); // Max limit 100
          setPoints(totalPoints);
        } catch (error) {
          console.error("Error fetching user points:", error);
        }
      }
    };

    fetchUserPoints();
  }, []);

  const handleRedeem = () => {
    if (points < maxPoints) {
      alert("Before redeeming points, you must accomplish 100 points.");
      return;
    }
    // Proceed with redeem logic here
    console.log("Redeeming points...");
  };

  const progress = (points / maxPoints) * 100;

  return (
    <>
    <section className="hero">
  <div className="hero-image">
      <img src="/imgbook.png" alt="Books and Research" />
    </div>
    <div className="hero-content">
      <h1>Eye Care Digital Library</h1>
      <p>Your gateway to advanced research and resources in optometry and vision science.</p>
    </div>
</section>

    <div className="earn-point-container">
      <h2 className="earn-point-title">Your Earned Points</h2>
      <div className="point-bar-container">
        <div className="point-bar" style={{ width: `${progress}%` }}></div>
      </div>
      <p className="point-text">{points} / {maxPoints} Points</p>
      <button className='redeem-button' onClick={handleRedeem}>Redeem Points</button>
    </div>
  </>
    

  );
}

export default EarnPoint;

